module.exports = __webpack_public_path__ + "assets/img/18_1787_big.57c4dc20.jpg";